import React from 'react';

export default function AuditPage({ onAuditClick }) {
    return (
        <div className="bg-warm-pearl min-h-screen">
            {/* Hero Section */}
            <section className="px-6 py-24 md:py-32 max-w-7xl mx-auto">
                <div className="flex flex-col items-center text-center">
                    <h1 className="text-espresso massive-score mb-8 leading-none">Web Accessibility,<br />Translated.</h1>
                    <p className="text-espresso text-xl md:text-2xl font-medium mb-12 opacity-90 max-w-3xl">
                        Technical WCAG checks for designers, agencies, and pros. Simplified results for your clients.
                    </p>
                    <button
                        onClick={onAuditClick}
                        className="pill-button text-lg px-10 py-4 shadow-lg mb-20"
                    >
                        Run A Direct Audit
                    </button>
                </div>

                {/* Features Bento Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bento-card bg-stone md:col-span-2">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="text-4xl">🔬</span>
                            <h2 className="text-espresso text-2xl font-black">Full Matrix Analysis</h2>
                        </div>
                        <p className="text-espresso opacity-70 mb-8">
                            Our engine performs over 80 automated WCAG 2.1 Level AA & AAA checks,
                            covering everything from ARIA sequences to keyboard trap detections.
                        </p>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="bg-warm-pearl p-4 rounded-xl border border-teal/10">
                                <div className="text-teal font-black mb-1">Color Contrast</div>
                                <div className="text-espresso/60 text-sm">Matrix verification</div>
                            </div>
                            <div className="bg-warm-pearl p-4 rounded-xl border border-teal/10">
                                <div className="text-teal font-black mb-1">DOM Sequence</div>
                                <div className="text-espresso/60 text-sm">Linear flow audit</div>
                            </div>
                        </div>
                    </div>
                    <div className="bento-card bg-teal text-warm-pearl">
                        <div className="flex flex-col h-full justify-between">
                            <div>
                                <h2 className="text-2xl font-black mb-4">API Access</h2>
                                <p className="opacity-80">Integrate our scanner directly into your CI/CD pipeline or agency dashboard.</p>
                            </div>
                            <div className="mt-8 font-mono text-sm bg-black/20 p-4 rounded-lg">
                                curl -X POST /v1/scan
                            </div>
                        </div>
                    </div>
                    <div className="bento-card bg-warm-pearl border-2 border-teal/20">
                        <h2 className="text-espresso text-xl font-bold mb-4">White-Label Reports</h2>
                        <p className="text-espresso opacity-70">Generate branded PDF reports that your clients can actually understand. No tech-speak, just results.</p>
                    </div>
                    <div className="bento-card bg-stone md:col-span-2">
                        <div className="flex flex-col md:flex-row gap-8 items-center">
                            <div className="flex-1">
                                <h2 className="text-espresso text-2xl font-black mb-4">Agency Tier</h2>
                                <p className="text-espresso opacity-70">
                                    Manage multiple client sites from one central hub. Run automated weekly scans and get alerted before a minor update creates a major legal risk.
                                </p>
                            </div>
                            <button className="pill-button whitespace-nowrap">Contact Sales</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Support/Resource Section */}
            <section className="bg-stone py-20 px-6 mt-12 text-center">
                <div className="max-w-3xl mx-auto">
                    <h2 className="text-espresso text-2xl font-bold mb-6 italic opacity-50">"The easiest way to sell accessibility to my clients."</h2>
                    <p className="text-espresso opacity-60">— David G., Freelance Web Designer</p>
                </div>
            </section>
        </div>
    );
}
